<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Dämmerlicht des Föhrenwalds</h3>
<h4 class="calibre7 sigil_not_in_toc">I</h4>
<p class="vers">Dämmerlicht des Föhrenwalds<br class="calibre2"/>
nahm mich auf in seine Tiefen;<br class="calibre2"/>
hing der Schnee am müden Zweig,<br class="calibre2"/>
und die grauen Krähen riefen.</p>
<p class="vers">Fiel die Flocke matt und stumm<br class="calibre2"/>
aus dem weiten, grauen Raume;<br class="calibre2"/>
hin und wieder brach ein Ast<br class="calibre2"/>
schneebeschwert vom Föhrenbaume.</p>
<p class="vers"><a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page27" title="wedi/Konmax"></a> Kam ich an ein Totenfeld,<br class="calibre2"/>
standen Kreuze tief im Eise;<br class="calibre2"/>
lagen Kränze, längst verwelkt,<br class="calibre2"/>
raschelten im Winde leise.</p>
<p class="vers">Mußte ob des leisen Sangs,<br class="calibre2"/>
den sie miteinander sangen,<br class="calibre2"/>
mußte, weil ich ihn verstand,<br class="calibre2"/>
heimlich an zu weinen fangen.</p>
<p class="vers">»Mag ich reden noch so leis,<br class="calibre2"/>
mag mich nimmer übertönen<br class="calibre2"/>
jener, der da unten ruht:<br class="calibre2"/>
einer von den Musensöhnen.</p>
<p class="vers">Jener, der dahingetobt<br class="calibre2"/>
einstens wie mit Sturmesschwingen,<br class="calibre2"/>
übertönt mich nun nicht mehr,<br class="calibre2"/>
mag ich noch so leise singen.«</p>
<p class="vers">Also sprach das Lorbeerblatt.<br class="calibre2"/>
Heimwärts wandt' ich meine Schritte;<br class="calibre2"/>
hinter mir, vom Wind verweht,<br class="calibre2"/>
schwand die Spur auch meiner Tritte.</p>
<h4 class="calibre7 sigil_not_in_toc">II</h4>
<p class="vers">Wiederum im Föhrenwald<br class="calibre2"/>
stand ich an der Kirchhofsmauer;<br class="calibre2"/>
war ein Grab, und drum gereiht<br class="calibre2"/>
harrten sie in stummer Trauer,<br class="calibre2"/>
und der Priester im Ornat<br class="calibre2"/>
spendete des Gottes Rat:<br class="calibre2"/>
»Tröstet euch!«</p>
<p class="vers">Doch ich stützte in die Hand<br class="calibre2"/>
mir das Haupt, es wollte sinken,<br class="calibre2"/>
konnte aus des Priesters Wort<br class="calibre2"/>
keinen Trost für mich ertrinken,<br class="calibre2"/>
hörte wohl die Botschaft mild,<br class="calibre2"/>
doch im Busen tobte wild<br class="calibre2"/>
Zweifelsqual.</p>
<p class="vers"><a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page28" title="wedi/Konmax"></a> »Jesus, meine Zuversicht«<br class="calibre2"/>
sangen sie im ernsten Chore,<br class="calibre2"/>
und es flatterten im Wind<br class="calibre2"/>
weiße Tücher, schwarze Flore.<br class="calibre2"/>
Weiße Tücher, schwarzer Flor,<br class="calibre2"/>
Tränen quollen draus hervor.<br class="calibre2"/>
Tröstet euch!</p>
<p class="vers">»Tröstet euch«, so sprach ich leis.<br class="calibre2"/>
Könnt' ich, Arme, Trost euch geben!<br class="calibre2"/>
Fingen sie von neuem an:<br class="calibre2"/>
»Christ, mein Heiland, ist im Leben.«<br class="calibre2"/>
Doch da überlief's mich heiß,<br class="calibre2"/>
weil ich's leider besser weiß.<br class="calibre2"/>
Schwacher Trost.</p>
<p class="vers">Aber bittrer, tiefer Schmerz<br class="calibre2"/>
machte meine Lippen beben.<br class="calibre2"/>
»Christus lebt, wie sollt' ich nicht<br class="calibre2"/>
darum mich zufrieden geben?«<br class="calibre2"/>
fielen sie von neuem ein,<br class="calibre2"/>
und so senkte man ihn ein.<br class="calibre2"/>
Bittrer Hohn.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0013.vue?09c99758